import React from "react";
import { useState } from "react";
import { voipFaqs } from "../components/faqData.js";
import Contact from "../components/Contact.js";
import GetInTouch from "../components/GetInTouch.js";

const VoIPBusinessSolutions = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-10 mt-20">
      <div className=" rounded-lg p-10 py-20 max-w-5xl text-center mb-20">
        <h1 className=" sm:text-4xl md:text-xl lg:text-6xl font-bold mb-4">
          VoIP Solutions for Modern Businesses
        </h1>
        <p className="text-lg text-gray-700 mb-2">
          Unlock the potential of Voice over Internet Protocol (VoIP) to enhance
          communication across multiple devices like desktops, mobile phones,
          and VoIP-enabled hardware. With the right VoIP solution, you can enjoy
          high-quality, cost-effective calling services through the internet,
          ensuring seamless connectivity for your business.
        </p>
        <button
          onClick={() =>
            window.scrollTo({ top: window.innerHeight, behavior: "smooth" })
          }
          className="mt-20 mb-10 bg-blue-700 text-white px-6 py-3 rounded-full hover:bg-blue-600 transition duration-300"
        >
          Scroll Down
        </button>
      </div>

      <div className=" py-5 px-5 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
          <div className="flex justify-center lg:w-1/4 mb-12 lg:mb-0">
            <img
              src="\assets\images\homeImages\viopDev.avif"
              alt="VoIP Business Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="lg:w-3/4 text-center lg:text-left p-6">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Unlock the Potential of Advanced VoIP Solutions
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
              Our innovative VoIP solutions are crafted to transform how your
              business communicates, ensuring scalability, flexibility, and
              top-notch performance. We’ve analyzed the future of digital
              communication, and we believe that IP-based systems offer
              unmatched reliability, clearer voice quality, and the ability to
              easily adapt to your evolving needs. By partnering with us, you'll
              leverage cutting-edge internet telephony to elevate your
              communication above the competition.
              <br />
              <br />
              As a trusted provider of personalized VoIP solutions, our expert
              developers can create tailored communication tools that suit your
              business's specific requirements. With years of experience and a
              deep understanding of the VoIP landscape, Ayanshtech delivers
              cost-effective, high-quality solutions that enhance efficiency and
              streamline operations, saving you both time and money.
            </p>
          </div>
        </div>
      </div>
      <div className="lg:w-3/4 text-center lg:text-left p-6">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
          Transform Your Business with Innovative VoIP Solutions
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
          Get ahead of your competitors with our customized VoIP solutions
          designed to optimize your communication. Our services focus on
          creating adaptable, high-performance systems that ensure seamless
          connections, whether you are at the office, traveling, or working
          remotely. With crystal-clear voice quality, exceptional reliability,
          and scalable features, our VoIP solutions empower businesses to
          communicate more efficiently than ever before.
          <br />
          <br />
          At Ayanshtech, we are committed to delivering personalized VoIP
          services tailored to your business’s specific needs. Our skilled team
          leverages cutting-edge technologies to create secure, cost-effective,
          and scalable solutions, enabling you to stay connected and boost
          productivity, no matter where your team is located.
        </p>
      </div>

      <div className="relative flex flex-col space-y-4  rounded-lg p-6">
        <div className="text-center mb-16 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Our Tailored VoIP Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-2xl mx-auto ">
            At Ayanshtech, we specialize in providing a wide range of custom
            VoIP solutions designed to enhance your business communication and
            meet your specific needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto ">
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">
              Session Border Controller
            </h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Secure and manage internet telephony traffic at network borders,
              ensuring efficient signaling and media flow control.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">Hosted PBX Solutions</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Streamline communication management across multiple teams,
              customers, and locations with our cost-effective software
              platform.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">Wholesale VoIP Switch</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Manage large-scale VoIP traffic and services across multiple
              networks using advanced Class 4 Softswitch technology.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">Retail VoIP Switch</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Enable advanced features like voicemail, SMS, and call management,
              including billing and routing functionalities.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">
              Unified Communication Platform
            </h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Connect all your business communication tools voice, video,
              messaging, and content sharing—into one seamless platform.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">Dynamic IVR Solution</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Create user-friendly, scalable multi-tenant solutions with
              customizable routing, time-zone support, and DID numbers.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">
              Voice/SMS Broadcasting Solution
            </h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Send pre-recorded voice messages and SMS to a large audience
              quickly and efficiently.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">MVNO Solution</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Gain full control over service delivery and improve operational
              efficiency while expanding your customer base.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">Contact Center</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Enhance customer experience by offering multichannel support
              including calls, chat, web interactions, and more.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">
              Audio/Video Conference Solution
            </h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Boost team collaboration and productivity with top-tier audio and
              video conferencing services.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">Fax over IP</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Send faxes over the internet securely and cost-effectively using
              regular fax machines, ideal for VoIP users.
            </p>
          </div>
          <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
            <h3 className="font-bold text-xl mb-2">Telepresence</h3>
            <p className="sm:text-base md:text-lg lg:text-xl">
              Enhance remote team collaboration and video conferencing with our
              cutting-edge telepresence solutions.
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mb-10 mt-10">
        <h2 className="sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800">
          Technologies We use
        </h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8 px-15">
        <div className="position:relative; z-8 ">
          <img
            src="/assets/images/voipComponent/VoipTech/1.png"
            alt="Voip tech"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
          />
        </div>
        <div className="position:relative; z-8">
          <img
            src="/assets/images/voipComponent/VoipTech/2.png"
            alt="Voip tech"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
          />
        </div>
        <div className="position:relative; z-8">
          <img
            src="/assets/images/voipComponent/VoipTech/3.png"
            alt="Voip tech"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
          />
        </div>
        <div className="position:relative; z-8">
          <img
            src="/assets/images/voipComponent/VoipTech/4.png"
            alt="Voip tech"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
          />
        </div>
        <div className="position:relative; z-8">
          <img
            src="/assets/images/voipComponent/VoipTech/5.png"
            alt="Voip tech"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
          />
        </div>
      </div>

      <div className="w-full max-w-7xl bg-blue-800 text-white py-8 px-4 rounded-2xl mt-10 mx-auto ">
        <div className=" mx-auto text-center flex justify-center md:justify-between items-center">
          <h2 className="text-xl md:text-2xl lg:text-3xl  mb-2">
            Maximize Your Business Potential – Start Your Journey to Success
            Today!
          </h2>
          <button className="bg-green-500 px-4 py-2 ml-6 rounded-full ">
            Get Started
          </button>
        </div>
      </div>

      <div className="text-center mb-16 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          AyanshTech: Pioneering VoIP Solutions for Your Business
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-bold mt-4 max-w-2xl mx-auto">
          Here's how we add value to your business:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
        <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
          <p className="sm:text-base md:text-lg lg:text-xl">
            We deeply analyze your requirements and create tailored solutions
            that truly resonate with your needs.
          </p>
        </div>
        <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
          <p className="sm:text-base md:text-lg lg:text-xl">
            With over 10 years of expertise, our team is equipped with a
            comprehensive understanding of VoIP technology.
          </p>
        </div>
        <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
          <p className="sm:text-base md:text-lg lg:text-xl">
            We specialize in providing custom solutions built entirely from the
            ground up.
          </p>
        </div>
        <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
          <p className="sm:text-base md:text-lg lg:text-xl">
            Our approach combines affordable pricing with top-notch quality to
            deliver solutions that outperform competitors.
          </p>
        </div>
        <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
          <p className="sm:text-base md:text-lg lg:text-xl">
            As a leading VoIP provider, we’ve earned recognition with multiple
            accolades in the industry.
          </p>
        </div>
        <div className="p-6  shadow-md rounded-lg hover:bg-gradient-to-r hover:from-blue-300 hover:to-green-200 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
          <p className="sm:text-base md:text-lg lg:text-xl">
            At Ayanshtech, we prioritize timely delivery, ensuring that projects
            are completed professionally and on schedule.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto p-6 py-20 w-full">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {voipFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index ? "bg-blue-600 text-white px-5" : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      {/* <section className=" px-20 ">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8">
            Latest Insights
          </h2>
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {InsightsArray.slice(0, 3).map((insight, index) => (
              <div
                key={index}
                className=" rounded-lg shadow-lg overflow-hidden"
              >
                <img
                  src={insight.image}
                  alt={insight.title}
                  className="w-full h-32 sm:h-40 md:h-48 lg:h-56 object-cover"
                />
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-semibold mb-2">
                    {insight.title}
                  </h3>
                  <p className="text-sm sm:text-base text-blue-500 mb-2">
                    {insight.category}
                  </p>
                  <p className="text-xs sm:text-sm text-gray-500">
                    {insight.date}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8"></div>
        </div>
      </section> */}

      <div id="contact-section">
        <Contact />
      </div>

      <GetInTouch />
    </div>
  );
};

export default VoIPBusinessSolutions;
